import React from "react";
import { SFDatagrid } from "@sf-core";

const GridExample = () => {
  const columnDefs = [
    {
      headerName: "Skill Code",
      field: "code",
    },
    { headerName: "Name", field: "name" },
    { headerName: "Parent", field: "parentSkill" },
    { headerName: "Category", field: "category" },
    { headerName: "Trend", field: "trend" },
    {
      headerName: "No of Jobs",
      field: "jobRoleCount",
    },
    {
      headerName: "No of Jobs Families",
      field: "jobFamilyCount",
    },
    {
      headerName: "Action",
      sortable: false,
      suppressMenu: true,
      headerComponentParams: {
        showFilter: false,
      },
      cellRenderer: "showMoreRenderer",
    },
  ];

  // const columnDefsJobs = [
  //   {
  //     headerName: <p>"Job Code",</p>,
  //     field: "code",
  //   },
  //   { headerName: "Name", field: "name" },
  //   { headerName: "Level", field: "level" },
  //   { headerName: "Trend", field: "trend" },
  //   { headerName: "Job Family", field: "jobFamily" },
  //   {
  //     headerName: "Discipline",
  //     field: "discipline",
  //   },
  //   {
  //     headerName: "No of Skills",
  //     field: "skillCount",
  //     filter: "agNumberColumnFilter",
  //   },
  // ];

  return (
    <>
      <SFDatagrid
        gridName="test"
        columnDefs={columnDefs}
        filterValuesUrl={"http://localhost:5001/api/getSkills/filterValues"}
        datasourceUrl={"http://localhost:5001/api/getSkills"}
        viewDetailsUrl={"benchmark-skills/skills"}
      />
      {/* <DataGrid
          columnDefs={columnDefsJobs}
          filterValuesUrl={"http://localhost:5001/api/getJobs/filterValues"}
          datasourceUrl={"http://localhost:5001/api/getJobs"}
        /> */}
    </>
  );
};

export default GridExample;
